module.exports = "<header class=\"site-header row\">\r\n    <div class=\"site-logo col-xs-9 col-sm-2\">\r\n        <a [routerLink]=\"'/'\">\r\n            <img src=\"../../assets/img/logo-white.svg\"/>\r\n        </a>\r\n    </div>\r\n    <div class=\"site-menu col-xs-3 col-sm-offset-9 col-sm-1 hide\" (click)=\"showSidebar()\">\r\n        <div><span>M</span><span>E</span></div>\r\n        <div><span>N</span><span>Y</span></div>\r\n    </div>\r\n</header>"


//////////////////
// WEBPACK FOOTER
// E:/MBP/BloomyNG/src/app/header/header.component.html
// module id = ../../../../../src/app/header/header.component.html
// module chunks = main